import React, { useState } from 'react';
import {
  Carousel,
  CarouselItem,
  CarouselControl,
  CarouselIndicators,
  CarouselCaption
} from 'reactstrap';

const items = [
 
  //{
  //  src: '/homeNow/images/bsompo-slider-cny2023-generic.jpg',
  //  altText: 'SOMPO HUAT 兔(to)gether Campaign',
  //  header: '',
  //  product: '',
  //  caption: '',
  //  link:'#goldsompo',
  //  scroll: true
  //},
  {
    src: '/homeNow/images/img-header-1440.jpg',
    altText: 'SOMPO HomeNow',
    header: '',
    product: 'SOMPO Home',
    caption: 'Adakah barangan peribadi anda dilindungi?',
    link:''
  }
];

const Slider = (props) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [animating, setAnimating] = useState(false);

  const next = () => {
    if (animating) return;
    const nextIndex = activeIndex === items.length - 1 ? 0 : activeIndex + 1;
    setActiveIndex(nextIndex);
  }

  const previous = () => {
    if (animating) return;
    const nextIndex = activeIndex === 0 ? items.length - 1 : activeIndex - 1;
    setActiveIndex(nextIndex);
  }

  const goToIndex = (newIndex) => {
    if (animating) return;
    setActiveIndex(newIndex);
  }

  const slides = items.map((item) => {
    return (
      <CarouselItem
        className="custom-tag"
        tag="div"
        onExiting={() => setAnimating(true)}
        onExited={() => setAnimating(false)}
        key={item.src}
      >
        {/* {item.link ? <a href={item.link} target="_blank"><img className="main-slider" src={item.src} alt={item.altText} /></a> : <img className="main-slider" src={item.src} alt={item.altText} />} */}
        
        { item.link ? <a href={item.link} target={ item.scroll ? "" : "_blank" }><img className="main-slider" src={item.src} alt={item.altText} /></a> : <img className="main-slider" src={item.src} alt={item.altText} /> }
       
        { item.product ?
          <div class="main-slider_caption">
            <div class="carousel-caption d-none d-md-block">
              <h3>{item.product}<span class="prod-name-italic">Now</span></h3>
              <p>{item.caption}</p>
            </div>
          </div> :
          <div className="main-slider_caption">
            <CarouselCaption captionText={item.caption} captionHeader={item.header} />
          </div>}
      </CarouselItem>
    );
  });

  return (
        <div>
      {/* <style>
        {
          `.custom-tag {
              max-width: 100%;
              height: 400px;
              background: black;
            }`
        }
      </style> */}
    <Carousel
      activeIndex={activeIndex}
      next={next}
      previous={previous}
    >
      {/* <CarouselIndicators items={items} activeIndex={activeIndex} onClickHandler={goToIndex} /> */}
      {slides}
      <CarouselControl direction="prev" directionText="Previous" onClickHandler={previous} />
      <CarouselControl direction="next" directionText="Next" onClickHandler={next} />
      </Carousel>
      </div>
  );
}

export default Slider;
